function logData(message) {
    return fetch(
        `${process.env.VUE_APP_FIREBASE_FUNCTION_ROOT}/logData/?message=${message}`
    );
}

export { logData };
